import {fromRxJS5} from "../app";

export default function MemberAccountSettingsCtrl($scope, progressBar, UserService, $wamp) {
  const members_uri = 'org.eggs.get_login_list_view_for_company';
  const member_credits_uri = 'org.eggs.get_login_credits_for_company';
  const add_role_uri = 'org.eggs.add_role_for_person';
  const remove_role_uri = 'org.eggs.remove_role_from_person';

  const tradersSub = UserService.subject
    .safeApply($scope, function (user) {
      $scope.user = user;
      progressBar.add(members_uri);
    })
    .flatMapFirst(function (user) {
      return fromRxJS5($wamp.thruway.progressiveCall(members_uri, [user.company_id]));
    })
    .map(res => res.args[0])
    .subscribe((members) => {
      $scope.$applyAsync(function () {
        $scope.members = members.map(function (m) {
          // console.log(m);
          m.trading = m.roles.indexOf('trading') >= 0;
          return m;
        });
      });

      progressBar.remove(members_uri);
    });

  const creditsSub = UserService.subject
    .safeApply($scope, function (user) {
      $scope.user = user;
      progressBar.add(member_credits_uri);
    })
    .flatMapFirst(function (user) {
      return fromRxJS5($wamp.thruway.progressiveCall(member_credits_uri, [user.company_id]));
    })
    .map(res => res.args[0])
    .subscribe((credits) => {
      const totalCreditsAvailable = credits
        .map(x => x.available ? (Number(x.buyer_credits_remaining) + Number(x.seller_credits_remaining)) : 0)
        .reduce((sum, value) => sum + value, 0);

      $scope.$applyAsync(() => {
        $scope.credits = credits;
        $scope.totalCreditsAvailable = totalCreditsAvailable;
      });
      progressBar.remove(member_credits_uri);
    });

  $scope.setTrading = function (member, prevValue) {
    member.error = null;
    member.disabled = true;
    progressBar.add('changing_trading_status');

    const rpc = member.trading
      ? $wamp.call(add_role_uri, [member.PersonID, 'trading'])
      : $wamp.call(remove_role_uri, [member.PersonID, 'trading']);

    rpc.then(
      function () {
        member.disabled = false;
        progressBar.remove('changing_trading_status');
      },
      function (e) {
        member.error = 'There was an error ' + (member.trading ? 'enabling' : 'disabling') + ' trading';
        // Reset the value to the previous if the rpc fails;
        member.trading = prevValue;
        member.disabled = false;
        progressBar.remove('changing_trading_status');
        // console.log(e);
      });
  };

  $scope.$on('$destroy', function () {
    // console.log('disposed');
    tradersSub.dispose();
    creditsSub.dispose();
  });
}
